import { Grid, Typography } from '@mui/material';
import { HotKeys, KeyMap } from 'react-hotkeys';
import { connect, useDispatch } from 'react-redux';
import PriceButtons from '../../features/price/PriceButtons';
import PriceTable from '../../features/price/PriceTable';
import { RootState } from '../../store';
import { sortPricelistsHierarchically } from '../../utils';
import { PricelistDialog } from '../pricelist/PricelistDialog';
import { getPricelists } from '../pricelist/redux/pricelistSelectors';
import { getIsChoosePricelistsDialogOpen, getSelectedPricelistIds } from './redux/priceSelectors';
import {
    closeChoosePricelistsDialog,
    priceTablePricelistsSelected,
    toggleApplyCalculations
} from './redux/priceSlices';

const mapStateToProps = (state: RootState) => ({
    selectedPricelistIds: getSelectedPricelistIds(state),
    isPricelistDialogOpen: getIsChoosePricelistsDialogOpen(state),
    pricelists: getPricelists(state)
});

type Props = ReturnType<typeof mapStateToProps>;

type PriceKeyMap = KeyMap & {
    toggleApplyCalculations: string;
};

export const priceKeyMap: PriceKeyMap = {
    toggleApplyCalculations: 'Ctrl+k'
};

const Price = ({ selectedPricelistIds, isPricelistDialogOpen, pricelists }: Props) => {
    const dispatch = useDispatch();

    const keyMapHandlers: {
        [key: string]: (keyEvent?: KeyboardEvent | undefined) => void;
    } = {
        toggleApplyCalculations: event => {
            dispatch(toggleApplyCalculations());
            if (event != null) {
                event.preventDefault();
            }
        }
    };

    const handlePricelistDialogClosed = () => {
        dispatch(closeChoosePricelistsDialog());
    };

    const handlePricelistsSelected = (pricelistIds: number | number[]) => {
        const sortedPricelistIds = sortPricelistsHierarchically(pricelistIds as number[], pricelists);
        dispatch(priceTablePricelistsSelected(sortedPricelistIds));
    };

    return (
        <HotKeys keyMap={priceKeyMap} handlers={keyMapHandlers}>
            <Grid
                sx={{
                    '&:focus': {
                        outline: '0'
                    }
                }}
                container
                spacing={1}
            >
                <Grid item xs={12}>
                    <PriceButtons />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="subtitle1">
                        {selectedPricelistIds.length === 0
                            ? 'Choose pricelists first in order to change prices'
                            : ''}
                    </Typography>
                </Grid>

                <Grid item xs={12} style={{ height: '82vh' }}>
                    <PriceTable />
                </Grid>

                {isPricelistDialogOpen && (
                    <PricelistDialog
                        handleClose={handlePricelistDialogClosed}
                        multiSelect={true}
                        selectedPricelistIds={selectedPricelistIds}
                        pricelistsSelected={handlePricelistsSelected}
                    />
                )}
            </Grid>
        </HotKeys>
    );
};

export default connect(mapStateToProps)(Price);
